module.exports = __webpack_public_path__ + "img/bot_intent_rg.b39a70b9.svg";